var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form-group" },
    [
      _vm.label
        ? _c("label", { attrs: { for: _vm.name } }, [_vm._v(_vm._s(_vm.label))])
        : _vm._e(),
      _vm.required
        ? _c("span", { staticClass: "text-danger" }, [_vm._v(" *")])
        : _vm._e(),
      _vm._v(" "),
      _c("file-pond", {
        ref: _vm.name,
        attrs: {
          id: _vm.name,
          name: _vm.name,
          "label-idle": _vm.Lang.get("messages.upload-label"),
          "allow-multiple": _vm.multiple,
          "accepted-file-types": _vm.filesTypes,
          server: _vm.server,
          files: _vm.myFiles,
          disabled: _vm.disabled,
        },
        on: {
          removefile: _vm.onFileRemoved,
          removeFile: _vm.onFileRemoved,
          remove: _vm.onFileRemoved,
        },
      }),
      _vm._v(" "),
      _vm.localErrors[_vm.error_name || _vm.name]
        ? _c("small", {
            staticClass: "form-text text-danger",
            domProps: {
              textContent: _vm._s(
                _vm.localErrors[_vm.error_name || _vm.name][0]
              ),
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }